import { css, styled } from '@styles/theme'

export const questionStyles = {
	container: css({}),

	containerQuestion: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'baseline',
		padding: '16px',
		gap: '16px',
		width: '100%',
		height: '100%',
		minHeight: '148px',
		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',
	}),

	numberContainer: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',

		minWidth: '26px',
		height: '30px',

		background: '$neutral20',
		border: '1px solid $neutral50',
		borderRadius: '4px',

		_font: 'medium',
		fontWeight: 500,
		fontSize: ' 14px',
		lineHeight: '21px',
		letterSpacing: '0.05em',
		color: '$neutral150',
	}),

	radioGroup: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
		margin: '32px 0px',
	}),

	errorSpan: css({
		width: '100%',
		maxWidth: '189px',

		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '8px',

		_font: 'normal',
		fontWeight: 400,
		fontSize: '16px',
		lineHeight: '21px',
		letterSpacing: '0.05em',

		color: '$red',

		svg: {
			width: '24px',
			height: '24px',
		},
	}),

	containerButton: css({ display: 'flex', justifyContent: 'space-between' }),

	containerActionBar: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
		height: '100%',
		minHeight: ' 57px',
		padding: '16px',
		margin: '32px 0px',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',

		cursor: 'pointer',
	}),

	containerDeleteQuestionNotebook: css({
		display: 'flex',
		justifyContent: 'flex-end',
		button: {
			cursor: 'pointer',
		},
	}),

	ActionBar: styled('button', {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		p: {
			_font: 'normal',
			fontWeight: 500,
			fontSize: '14px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$neutral100',
		},

		'&:hover': {
			color: '$primary',
			svg: {
				color: '$primary',
			},
			p: {
				color: '$primary',
			},
		},

		variants: {
			selected: {
				true: {
					p: {
						color: '$primary',
					},
					svg: {
						color: '$primary',
					},
				},
			},
		},
	}),

	Icon: styled('div', {
		display: 'flex',
		alignItems: 'center',

		width: '25px',
		height: '25px',
		background: '$neutral40',
		borderRadius: '6px',
		justifyContent: 'center',
		color: '$neutral100',

		svg: {
			width: '20px',
			height: '20px',
		},
	}),

	feedbackContainer: css({
		display: 'flex',
		flexDirection: 'column',
		padding: '32px',
		gap: '9px',
		margin: '59px 0px',

		width: '100%',
		height: '100%',

		background: 'rgba(107, 187, 220, 0.08)',
		borderRadius: '12px',

		h5: {
			_font: 'normal',
			fontWeight: 500,
			fontSize: '16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$red',
		},

		p: {
			_font: 'normal',
			fontWeight: 400,
			fontSize: '16px',
			lineHeight: '21px',
			letterSpacing: '0.05em',
			color: '$neutral120',

			strong: {
				color: '$red',
			},
		},
	}),
}
